import { objectStorageUrl } from '@/features/shared/utils/objectStorageUrl'
import { cmsRoutes, getRetailerUrl, routes } from '@shared/constants/routes'

export type Hyperlink = {
  name: string
  url: string
  /** True if the route is not an internal Segway route. When this is
  the case, we should render a plain <a> tag rather than <NextLink>. */
  external?: true
  target?: '_blank'
  rectangular_image?: string
  showUnderline?: true
}

export const BLOG_LINK = {
  name: 'Blog',
  url: routes.BLOG.url,
} as const satisfies Hyperlink

export const CAREERS_LINK = {
  name: 'Careers',
  url: `${routes.CORPORATE.url}/careers`,
  external: true,
} as const satisfies Hyperlink

export const HELP_LINK = {
  name: 'Help',
  url: 'https://help.shipt.com',
  external: true,
} as const satisfies Hyperlink

/** Dedicated priority support phone line for active Business Profile members */
export const PRIORITY_SUPPORT_PHONE = {
  name: '(205) 502-4252',
  url: 'tel:+12055024252',
} as const satisfies Hyperlink

/** Standard customer support phone line */
export const STANDARD_SUPPORT_PHONE = {
  name: '1 (205) 502-2500',
  url: 'tel:+12055022500',
} as const satisfies Hyperlink

export const NEWS_LINK = {
  name: 'Newsroom',
  url: 'https://corporate.shipt.com/news',
  external: true,
} as const satisfies Hyperlink

// partner pages are managed in the CMS via the /partnershipt/* slug
export const PARTNERSHIPS_LINK = {
  url: 'https://partner.shipt.com/join',
  name: 'Partners',
  external: true,
} as const satisfies Hyperlink

export const SHIPT_VS_INSTACART = {
  name: 'Shipt vs Instacart',
  url: `${routes.LP.url}/shipt-vs-instacart`,
} as const satisfies Hyperlink

export const SHIPT_BUSINESS_LINK = {
  name: 'Shipt Business',
  url: cmsRoutes.SHIPT_BUSINESS,
} as const satisfies Hyperlink

export const HOW_SHIPT_WORKS_LINK = {
  name: 'How Shipt works',
  url: 'https://help.shipt.com/how-shipt-works',
  external: true,
} as const satisfies Hyperlink

export const TARGET_PARTNERSHIP_LINK = {
  name: 'Target Partnership',
  url: `${routes.ABOUT.url}/target-partnership`,
} as const satisfies Hyperlink

// These retailers are intentionally hardcoded. These are the top stores
// that Shipt users frequently shop at.
export const SHOP_LINKS = [
  {
    name: 'Target',
    url: getRetailerUrl('target'),
    rectangular_image: objectStorageUrl('rectangular-target.png'),
  },
  {
    name: 'Kroger',
    url: getRetailerUrl('kroger'),
    rectangular_image: objectStorageUrl('rectangular-kroger.png'),
  },
  {
    name: 'Meijer',
    url: getRetailerUrl('meijer'),
    rectangular_image: objectStorageUrl('rectangular-meijer.png'),
  },
  {
    name: 'View all',
    url: routes.STORES.url,
  },
] as const satisfies Hyperlink[]

export const MAKE_MONEY_LINKS = [
  { url: cmsRoutes.SHOPPER.BE_A_SHOPPER, name: 'Be a shopper' },
  { url: cmsRoutes.DRIVER.BE_A_DRIVER, name: 'Be a driver' },
  { url: `${routes.PARTNER.url}/affiliate`, name: 'Be an affiliate' },
] as const satisfies Hyperlink[]

export const ABOUT_US_LINKS = [
  SHIPT_VS_INSTACART,
  HOW_SHIPT_WORKS_LINK,
  TARGET_PARTNERSHIP_LINK,
  PARTNERSHIPS_LINK,
  SHIPT_BUSINESS_LINK,
  NEWS_LINK,
  BLOG_LINK,
  ...MAKE_MONEY_LINKS,
  CAREERS_LINK,
  HELP_LINK,
] as const satisfies Hyperlink[]
